import React from "react";

import { Navbar } from "../../../components";
import { CodamDevelopment } from "./CodamDevelopment";

const CodamDevelopmentProject = () => {
  return (
    <div className="app">
      <Navbar />
      <CodamDevelopment />
    </div>
  );
};

export default CodamDevelopmentProject;
